// ModalContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import CallDetailModal from './CallDetailModal';

// Create the context
const ModalContext = createContext(null);

// Provider component that will wrap your application
export const ModalProvider = ({ children }) => {
    const [modalState, setModalState] = useState({
        callId: null,
        visible: false
    });

    // Show modal with specific call ID
    const showCallModal = useCallback((callId) => {
        setModalState({
            callId,
            visible: true
        });
    }, []);

    // Hide modal
    const hideCallModal = useCallback(() => {
        setModalState(prev => ({
            ...prev,
            visible: false
        }));
        // Optional: Clear call ID after a delay
        // setTimeout(() => {
        //   setModalState(prev => ({ ...prev, callId: null }));
        // }, 300);
    }, []);

    return (
        <ModalContext.Provider value={{ showCallModal, hideCallModal }}>
            {children}
            <CallDetailModal
                callId={modalState.callId}
                visible={modalState.visible}
                onClose={hideCallModal}
            />
        </ModalContext.Provider>
    );
};

// Custom hook for components to access the modal functionality
export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};
